module.exports = __webpack_public_path__ + "static/img/logo_cl_white.a2b7c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_cl_white.png
// module id = Nz2H
// module chunks = 0